<div class="faqs">
    <div class="title">FAQs</div>
    <div class="d-flex justify-content-center">
      <div>
        <div class="sub-header"><h4>General</h4></div>
        <ol style="list-style: none">
          <li class="question">Q: How do I reset my password?
              <ol type="A">
                  <li class="answer">
                  Please contact your school district's IT Department to reset your password.
                  </li>
              </ol>
          </li>
        </ol>
        <div class="sub-header"><h4>Claims</h4></div>
        <ol style="list-style: none">
            <li class="question">Q1: Are you able to view claims that are mailed, faxed or emailed to HSR?
                <ol type="A">
                    <li class="answer">
                    No, you are only able to view claims submitted via Fast Track.
                    </li>
                </ol>
            </li>
            <li class="question">Q2: Can you make changes to a claim that is in a Submitted status?
                <ol type="A">
                    <li class="answer">No, you will need to contact <a href="mailto:clientrelations@hsri.com">clientrelations@hsri.com</a>.</li>
                    </ol>
            </li>
            <li class="question">Q3: Can you complete a claim form without a parent’s signature?
                <ol type="A">
                    <li class="answer">Yes, by entering Signature is on file in the Parent/Legal Guardian signature field.</li>
                </ol>
            </li>
        </ol>
        <div class="sub-header"><h4>Rosters</h4></div>
        <div>
            <ol style="list-style: none">
                <li class="question">Q: Can you make changes to a roster that has been submitted?
                    <ol type="A">
                        <li class="answer">
                            No, you will need to contact <a href="mailto:clientrelations@hsri.com">clientrelations@hsri.com</a>.
                        </li>
                    </ol>
                </li>
            </ol>
        </div>
      </div>
  </div>
</div>
